import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=0652f6bd&scoped=true"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"
import style0 from "./RecipeCard.vue?vue&type=style&index=0&id=0652f6bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652f6bd",
  null
  
)

export default component.exports